import * as React from 'react';
import { connect } from 'react-redux';

import { IStore } from '../../types/store';
import { IMagazineItem } from '../../types/magazine';
import { IDigestState } from '../../types/digest';
import { IConfig } from '../../types/config';
import { Magazine } from '../../components/magazine/magazine';

interface IProps {
  journal: IMagazineItem[];
  digest: IDigestState;
  config: IConfig;
}

export class MagazineBlock extends React.Component<IProps, {}> {
  public render() {
    const news = this.getNews();
    const articles = this.getArticles();
    const blogs = this.getBlogs();
    const questions = this.getQuestions();

    const isNotAllData = !news.length && !articles.length && !blogs.length && !questions.length;

    if (isNotAllData) {
      return null;
    }

    return (
      <Magazine
        contentUrl={this.props.config.frontContentUrl}
        news={news}
        articles={articles}
        blogs={blogs}
        questions={questions}
        digestState={this.props.digest}
      />
    );
  }

  private getNews() {
    return this.props.journal.filter(item => item.attributes.type === 'news').slice(0, 6);
  }

  private getArticles() {
    return this.props.journal.filter(item => item.attributes.type === 'articles').slice(0, 4);
  }

  private getBlogs() {
    return this.props.journal.filter(item => item.attributes.type === 'blogs').slice(0, 3);
  }

  private getQuestions() {
    return this.props.journal.filter(item => item.attributes.type === 'questions').slice(0, 4);
  }
}

const mapStateToProps = (state: IStore) => ({
  journal: state.mainpage.contentPartData,
  digest: state.digest,
  config: state.config,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MagazineContainer = connect<{}, {}, any>(mapStateToProps)(MagazineBlock);
